import type { HelpFile } from '../../types/help'
import { TriggerFullEvaluationButtonTestIds } from '../../../testids/TriggerFullEvaluationButtonTestIds'

export const triggerFullEvaluationButtonHelp: HelpFile = {
  docPage: '/docs/governance/auto-assign-rules',
  texts: {
    [TriggerFullEvaluationButtonTestIds.btnTriggerFullEvaluation]:
      'Start-of-Day-Job sofort starten — wertet alle aktiven Auto-Zuweisungsregeln gegen alle aktiven Identitäten aus und schreibt die Änderungen.',
    [TriggerFullEvaluationButtonTestIds.btnTriggerFullEvaluationCancel]: null,
    [TriggerFullEvaluationButtonTestIds.btnTriggerFullEvaluationConfirm]:
      'Vollständige Auswertung bestätigen — der Job läuft im nächsten freien Scheduler-Slot.',
    [TriggerFullEvaluationButtonTestIds.triggerFullEvaluationDialog]:
      'Bestätigung vor dem Start einer vollständigen Regelauswertung über alle Identitäten.',
  },
}
